<template>
  <svg :width="width" :height="height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect :width="width" :height="height" rx="20"/>
    <path class="call_fill_hoverEffect" d="M25 15C18.9346 15 14 19.4623 14 24.9474C14 26.865 14.6039 28.7222 15.7483 30.3278C15.5316 32.7362 14.9508 34.5241 14.1075 35.3711C13.996 35.4831 13.9681 35.6544 14.0385 35.7959C14.1012 35.9223 14.2292 36 14.3667 36C14.3836 36 14.4008 35.9989 14.418 35.9963C14.5665 35.9753 18.0161 35.4761 20.5109 34.0297C21.9281 34.6041 23.4373 34.8947 25 34.8947C31.0654 34.8947 36 30.4324 36 24.9474C36 19.4623 31.0654 15 25 15Z" fill="#80B7FF"/>
  </svg>
</template>

<script>
import {colors} from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 20 },
    height: { type: [Number, String], default: 16 },
    color: { type: String, default:  colors.callIcon}
  },
  name: "IconCallChat"
}
</script>

<style scoped>
rect{
    fill: var(--backgroundColor);
}
</style>
